export default function tryEmit(...args) {
  if (!window.VueEventBus) {
    console.error('VueEventBus is not initialised');
    return;
  }
  window.VueEventBus.$emit(...args);
}
